/** Current hour (0..24, fractional) at an IANA timezone — for the activity ceiling. */
export function localHour(timezone: string, date: Date = new Date()): number {
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      hour: 'numeric',
      minute: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(date);
    const h = Number(parts.find((p) => p.type === 'hour')?.value ?? '12');
    const m = Number(parts.find((p) => p.type === 'minute')?.value ?? '0');
    return h + m / 60;
  } catch {
    return date.getHours() + date.getMinutes() / 60; // fall back to device clock
  }
}
